module.exports = __webpack_public_path__ + "img/homepageBannerCheese-old.d4ef39ba.jpg";